import { Loader2, Pause, Play } from "lucide-react";
import { fmtClock } from "@/lib/studioApi";

/** Hear your take over the music before you commit — touch-ups are applied when you press Replace. */
export default function LineUpPreview({ preview, disabled }) {
  const { state, playing, time, duration, toggle, seek } = preview;
  const pct = duration ? Math.min(100, (time / duration) * 100) : 0;
  const onSeek = (e) => {
    if (!duration) return;
    const r = e.currentTarget.getBoundingClientRect();
    seek(Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)) * duration);
  };
  return (
    <div data-testid="replace-preview" data-state={state} className="rounded-2xl border border-white/[0.08] bg-black/30 p-4">
      <div className="flex items-center gap-3">
        <button type="button" data-testid="replace-preview-play" onClick={toggle} disabled={disabled || state !== "ready"} aria-label={playing ? "Pause preview" : "Play preview"}
          className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-white text-[#05070f] transition-transform duration-200 hover:scale-105 disabled:opacity-40">
          {state === "loading" ? <Loader2 className="h-5 w-5 animate-spin" /> : playing ? <Pause className="h-5 w-5" /> : <Play className="ml-0.5 h-5 w-5" />}
        </button>
        <div className="min-w-0 flex-1">
          <div role="slider" tabIndex={0} aria-label="Seek preview" aria-valuemin={0} aria-valuemax={Math.round(duration)} aria-valuenow={Math.round(time)}
            data-testid="replace-preview-seek" onClick={onSeek} className="relative h-2 cursor-pointer rounded-full bg-white/10">
            <div className="absolute inset-y-0 left-0 rounded-full bg-gradient-to-r from-amber-300 to-rose-400" style={{ width: `${pct}%` }} />
          </div>
          <div className="mt-1 flex justify-between font-mono text-[10px] text-white/45">
            <span data-testid="replace-preview-time">{fmtClock(time)}</span><span>{fmtClock(duration)}</span>
          </div>
        </div>
      </div>
      <p className="mt-2 text-[11px] text-white/45">
        {state === "error" ? <span className="text-rose-300">The preview couldn't load — you can still replace the vocal.</span>
          : "Preview = your take as recorded over the music. Tuning and noise cleanup are added when you press Replace."}
      </p>
    </div>
  );
}
